var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.5L34 10L25.5 20H0L8.5 10L0 0Z",
    fill: "#253837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkArrow);
export default __webpack_public_path__ + "static/media/dark-arrow.87b13d5e225762058caee2f2c2e33097.svg";
export { ForwardRef as ReactComponent };